import React, { lazy } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import Blankslate from '../../components-v2/Blankslate';
import Page from '../../components-v2/Layout/Page';
import LoadingComponent from '../../components-v2/LoadingComponent';
import type { ResolvedTransactionModel } from './intents';
import { translateExplorerLocation } from './translateExplorerLocation';
import { useTransactionModel } from './useTransactionsLink';

const AllTransactionsV2 = lazy(() => import('../../components-v2/AllTransactions'));
const AllTransferGroupsV2 = lazy(() => import('../../components-v2/AllTransferGroups'));

export function TransactionsExplorerRoute({ page }: { page: ResolvedTransactionModel }) {
  const model = useTransactionModel();
  const history = useHistory();
  const location = useLocation();

  if (model === 'unresolved') {
    return (
      <Page>
        <LoadingComponent size="md" />
      </Page>
    );
  }

  if (model !== page) {
    const translation = translateExplorerLocation(location, model);
    if (translation.status === 'unsupported') {
      const pageName = model === 'legacy' ? 'Transactions' : 'Transfers';
      const { pathname, search } = translation.fallbackLocation;
      return (
        <Blankslate
          title="This saved transaction link cannot be opened as-is"
          subtitle={`Some filters in this link are not available on the ${pageName} page. You can continue without those filters.`}
          cta={`Open ${pageName} without these filters`}
          onClick={() => history.push(`${pathname}${search}`)}
        />
      );
    }
    return <Redirect to={translation.location} />;
  }

  return page === 'legacy' ? <AllTransactionsV2 /> : <AllTransferGroupsV2 />;
}
